<template>
  <div style="width:100%;">
    <el-popover placement="bottom-start" width="300" trigger="click">
      <el-button
        slot="reference"
        type="text"
        icon="el-icon-circle-plus-outline"
      >
        Add a Mediafile
      </el-button >

      <el-form class="form-modal">
        <audio id="mediafile-audio" style="display: none" src=""></audio>
        <el-input
          type="text"
          v-model="mediafileName"
          placeholder="Mediafile name"
        >
          <template slot="prefix">Mediafile Name</template>
        </el-input>

        <div class="mediafile-controls-flex flex align-center">
          <el-button
            v-loading="mediafilePlayPending"
            class="mediafile-play-button mr-5"
            :disabled="!!!mediafileBlob && !mediafileExists"
            :icon="mediafileIsPlaying ? 'mdi mdi-pause' : 'mdi mdi-play'"
            @click="mediafileIsPlaying ? pauseFile() : playFile()"
            circle
            type="primary"
          />
          <el-tooltip
            placement="top"
            content="Press and Hold To Record"
            class="flex align-center justify-center"
          >
            <div>
              <VueRecordAudio
                ref="vueRecorderMediafile"
                mode="hold"
                @stream="gotStreamMediafile"
                @result="onDoneRecordingMediafile"
              />
            </div>
          </el-tooltip>
          <el-tooltip placement="top" content="Upload File">
            <el-upload
              class="ml-5 mr-5"
              action="hailFred"
              accept="audio/*"
              :auto-upload="false"
              :on-change="showUploadedMediafile"
              :show-file-list="false"
            >
              <el-button class="mr-0" circle icon="el-icon-upload2" />
            </el-upload>
          </el-tooltip>

          <div class="mediafile-save-actions ml-30">
            <el-tooltip
              placement="top"
              content="Save Changes"
              v-if="mediafileChanged"
            >
              <el-button
                v-loading="processingRecording"
                type="primary"
                circle
                icon="mdi mdi-content-save"
                @click="saveMediafile"
              />
            </el-tooltip>
            <el-tooltip
              placement="top"
              content="Cancel Changes"
              v-if="mediafileChanged"
            >
              <el-button
                type="danger"
                circle
                icon="mdi mdi-cancel"
                @click="cancelChanges"
              />
            </el-tooltip>
          </div>
        </div>
      </el-form>
    </el-popover>
<!--    <el-button
      type="text"
      icon="el-icon-circle-plus-outline"
      @click="modalVisible = true"
    >
      Add a Mediafile
    </el-button >
    <el-dialog
      :visible.sync="modalVisible"
      title="Create a New Mediafile"
      width="30%"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form>
        <audio id="mediafile-audio" style="display: none" src=""></audio>
        <el-input
          type="text"
          v-model="mediafileName"
          placeholder="Mediafile name"
        >
          <template slot="prefix">Mediafile Name</template>
        </el-input>

        <div class="mediafile-controls-flex flex align-center">
          <el-button
            v-loading="mediafilePlayPending"
            class="mediafile-play-button mr-5"
            :disabled="!!!mediafileBlob && !mediafileExists"
            :icon="mediafileIsPlaying ? 'mdi mdi-pause' : 'mdi mdi-play'"
            @click="mediafileIsPlaying ? pauseFile() : playFile()"
            circle
            type="primary"
          />
          <el-tooltip
            placement="top"
            content="Press and Hold To Record"
            class="flex align-center justify-center"
          >
            <div>
              <VueRecordAudio
                ref="vueRecorderMediafile"
                mode="hold"
                @stream="gotStreamMediafile"
                @result="onDoneRecordingMediafile"
              />
            </div>
          </el-tooltip>
          <el-tooltip placement="top" content="Upload File">
            <el-upload
              class="ml-5 mr-5"
              action="hailFred"
              accept="audio/*"
              :auto-upload="false"
              :on-change="showUploadedMediafile"
              :show-file-list="false"
            >
              <el-button class="mr-0" circle icon="el-icon-upload2" />
            </el-upload>
          </el-tooltip>

          <div class="mediafile-save-actions ml-30">
            <el-tooltip
              placement="top"
              content="Save Changes"
              v-if="mediafileChanged"
            >
              <el-button
                v-loading="processingRecording"
                type="primary"
                circle
                icon="mdi mdi-content-save"
                @click="saveMediafile"
              />
            </el-tooltip>
            <el-tooltip
              placement="top"
              content="Cancel Changes"
              v-if="mediafileChanged"
            >
              <el-button
                type="danger"
                circle
                icon="mdi mdi-cancel"
                @click="cancelChanges"
              />
            </el-tooltip>
          </div>
        </div>
      </el-form>
    </el-dialog>-->
  </div>
</template>

<script>
import { hostServer } from "@/feathers/feathers-client";

export default {
  name: "NewMediafile",

  data() {
    return {
      mediafileIsPlaying: false,
      mediafileAudioElement: null,
      doneRecording: null,
      mediafileBlob: null,
      mediafileName: null,
      mediafileChanged: false,
      mediafileExists: false,
      mediafileDownloadPending: false,
      mediafilePlayPending: false,
      processingRecording: false,
      modalVisible: false
    };
  },
  computed: {
    user() {
      return this.$store.state.auth.user;
    },

    selectedTenant() {
      return this.$store.state.selectedTenant;
    }
  },

  methods: {
    gotStreamMediafile(data) {
      this.mediafileBlob = null;
      this.mediafileName = null;
      this.doneRecording = null;
    },

    onDoneRecordingMediafile(data) {
      this.doneRecording = true;
      this.mediafileBlob = data;
      this.mediafileAudioElement.src = window.URL.createObjectURL(data);
      this.mediafileName = this.recordedName;
      this.mediafileChanged = true;
    },

    async playFile() {
      if (!!this.mediafileBlob) {
        this.mediafileAudioElement.play();
        this.mediafileIsPlaying = true;
      }
    },

    pauseFile() {
      this.mediafileIsPlaying = false;
      this.mediafileAudioElement.pause();
      this.mediafileAudioElement.currentTime = 0;
    },

    cancelChanges() {
      this.mediafileBlob = null;
      this.mediafileName = null;
      this.mediafileChanged = false;
      this.doneRecording = false;
    },

    showUploadedMediafile(file) {
      this.mediafileBlob = new Blob([file.raw]);
      this.mediafileAudioElement.src = window.URL.createObjectURL(
        this.mediafileBlob
      );
      this.mediafileName = file.name.split(".")[0];
      this.mediafileChanged = true;
    },

    saveMediafile() {
      if (!this.mediafileName) {
        this.$notify({
          type: "warning",
          title: "Mediafile name is empty",
          message: "You must input the mediafile name."
        });
        return;
      }

      const mediaFile = this.mediafileBlob;
      this.processingRecording = true;

      let formData = new FormData();
      formData.append("mediaFile", mediaFile);
      formData.append("name", this.mediafileName);
      formData.append("tenantId", this.selectedTenant.id);

      fetch(`${hostServer}/mediafiles`, {
        method: "POST",
        body: formData,
        headers: {
          Authorization: `Bearer ${this.$store.state.auth.accessToken}`
        }
      })
        .then(res => res.json())
        .then(res => {
          this.processingRecording = false;
          this.mediafileExists = true;
          this.$emit("mediafileSaved", res);
          this.mediafileChanged = false;
          this.mediafileBlob = null;

          this.$notify({
            type: "success",
            title: "Mediafile Uploaded",
            message: "Your mediafile was successfully uploaded and applied."
          });
        });
    },

    setAudioBlob(buffer) {
      this.mediafileBlob = new Blob([buffer], { type: "audio/mp3" });
      this.mediafileAudioElement.src = window.URL.createObjectURL(
        this.mediafileBlob
      );
    },

    clearExistingMediafile() {
      this.mediafileBlob = null;
      this.mediafileName = null;
      this.mediafileExists = false;
      this.mediafileRecord = null;
    },

    setDownloadPending() {
      this.mediafileDownloadPending = !this.mediafileDownloadPending;
    },
    setPlayPending() {
      this.mediafilePlayPending = !this.mediafilePlayPending;
    },

    handleClose() {
      this.cancelChanges();
      this.clearExistingMediafile();
      this.modalVisible = false;
    }
  },

  mounted() {
    this.mediafileAudioElement = document.getElementById("mediafile-audio");
    this.mediafileAudioElement.addEventListener("ended", () => {
      this.mediafileIsPlaying = false;
    });
  }

  // destroyed() {
  //   this.mediafileAudioElement.removeListener("ended", () => true);
  // },
};
</script>

<style lang="scss" scoped>
.el-form {
  margin-top: 0;
  padding-top: 0 !important;
}

.vue-audio-recorder {
  width: 40px !important;
  height: 40px !important;
  background-color: #ef5350 !important;
}

.mediafile-play-button {
  width: 55px;
  height: 55px;
  i {
    font-size: 2em;
  }
}

hr {
  opacity: 0.25;
}
</style>
